<template>
    <section class="about-section container">
        <div class="summary-layout">
            <div class="summary-image">
                <lottie-player :src="lottieSource" class="ticker-animation" background="transparent" speed="1"
                    loopautoplay>
                </lottie-player>
            </div>
            <div class="summary-text">
                <lottie-player :src="require('@/assets/lottie/Summary Text.json')" class="ticker-animation"
                    background="transparent" speed="1" loop autoplay>
                </lottie-player>
                <div class="summary-box">
                    <img class="decor-icon" src="@/assets/images/second-arrow.png" alt="Decor" />
                    <h2>Abdul Moin Maroof</h2>
                    <p>
                        Senior Animator & Illustrator with 7+ years of experience in 2D animation, motion
                        design, and UI interaction. Proven success leading animation projects at Decojent,
                        ABTACH LTD, and Olivion Studios.
                    </p>
                </div>
            </div>
        </div>
        <div class="card-grid">
            <div class="card">
                <h3>Experience</h3>
                <p>Decojent<span class="muted"> (Dec 2021 – Present)</span></p>
                <p class="role">Senior Animator & Illustrator</p>
                <p>Intersys Ltd<span class="muted"> (Apr 2020 – Dec 2021)</span></p>
                <p class="role">Senior Executive – Video Animation</p>
                <p>Olivion Studios<span class="muted"> (Mar 2018 – Feb 2020)</span></p>
                <p class="role">2D Animator</p>
            </div>
            <div class="card">
                <h3>Education</h3>
                <p>ADMS From Arena Multimedia</p>
                <p class="muted role">Advance Diploma in Media Studies</p>
                <p>Intermediate</p>
                <p class="muted role">Higher Secondary Education Karachi</p>
                <p>Matriculation</p>
                <p class="muted role">Higher Secondary Education Karachi</p>
            </div>
            <div class="card client-card" style="padding-left: 0px; padding-right: 0px;">
                <lottie-player :src="require('@/assets/lottie/Client Logo - About US.json')" class="ticker-animation"
                    background="transparent" speed="1" style="width: 100%; height: 100%;" loop autoplay>
                </lottie-player>
                <p class="muted" style="padding-left: 24px; padding-right: 24px;">Working with</p>
                <h3 style="padding-left: 24px; padding-right: 24px;">Clients</h3>
                <div class="arrow-small">
                    <svg width="50" height="40" viewBox="0 0 50 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M30 28.75C30 23.913 26.087 20 21.25 20C26.087 20 30 16.087 30 11.25C30 16.087 33.913 20 38.75 20C33.913 20 30 23.913 30 28.75Z"
                            stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                        <path d="M23.75 20H0" stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                        <path
                            d="M12.5 25.8594C14.9392 33.3452 21.925 38.75 30.1622 38.75C40.428 38.75 48.75 30.3553 48.75 20C48.75 9.64466 40.428 1.25 30.1622 1.25C21.925 1.25 14.9392 6.65485 12.5 14.1406"
                            stroke="#444444" stroke-width="1.25" />
                    </svg>
                </div>
            </div>
        </div>
        <div class="card-grid" style="margin-top: 20px;">
            <div class="card icon-card">
                <div class="img_center" style="flex-direction: row; gap: 24px;">
                    <a href="https://dribbble.com/Moin-98" target="_blank">
                        <svg width="114" height="114" viewBox="0 0 114 114" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M30.4004 0.5H83.5996C100.113 0.5 113.5 13.8871 113.5 30.4004V83.5996C113.5 100.113 100.113 113.5 83.5996 113.5H30.4004C13.8871 113.5 0.5 100.113 0.5 83.5996V30.4004C0.5 13.8871 13.8871 0.5 30.4004 0.5Z"
                                fill="#F5F3EF" fill-opacity="0.02" />
                            <path
                                d="M30.4004 0.5H83.5996C100.113 0.5 113.5 13.8871 113.5 30.4004V83.5996C113.5 100.113 100.113 113.5 83.5996 113.5H30.4004C13.8871 113.5 0.5 100.113 0.5 83.5996V30.4004C0.5 13.8871 13.8871 0.5 30.4004 0.5Z"
                                stroke="url(#paint0_linear_33_87)" />
                            <circle cx="57" cy="57" r="21" stroke="white" stroke-width="2" />
                            <path d="M36 54.5C44.5 55 63.6 53.2 72 42" stroke="white" stroke-width="2" />
                            <path d="M78 58.5C70.3333 56 52.5 55.3 42.5 72.5" stroke="white" stroke-width="2" />
                            <path d="M49.5 37C54.1667 42.8333 64.1 58.8 66.5 76" stroke="white" stroke-width="2" />
                            <defs>
                                <linearGradient id="paint0_linear_33_87" x1="1.10145" y1="4.6594" x2="132.761"
                                    y2="48.8175" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#262626" />
                                    <stop offset="1" stop-color="#2C2C2C" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </a>
                    <a href="https://www.behance.net/abdulmoinmaroof" target="_blank">
                        <svg width="114" height="114" viewBox="0 0 114 114" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M30.4004 0.5H83.5996C100.113 0.5 113.5 13.8871 113.5 30.4004V83.5996C113.5 100.113 100.113 113.5 83.5996 113.5H30.4004C13.8871 113.5 0.5 100.113 0.5 83.5996V30.4004C0.5 13.8871 13.8871 0.5 30.4004 0.5Z"
                                fill="#F5F3EF" fill-opacity="0.02" />
                            <path
                                d="M30.4004 0.5H83.5996C100.113 0.5 113.5 13.8871 113.5 30.4004V83.5996C113.5 100.113 100.113 113.5 83.5996 113.5H30.4004C13.8871 113.5 0.5 100.113 0.5 83.5996V30.4004C0.5 13.8871 13.8871 0.5 30.4004 0.5Z"
                                stroke="url(#paint0_linear_33_99)" />
                            <path
                                d="M52.3851 55.8943C52.3851 55.8943 56.6939 55.5719 56.6939 50.5217C56.6939 45.4714 53.1695 43 48.6995 43H34V71.2492H48.6995C48.6995 71.2492 57.6717 71.5286 57.6717 62.9109C57.6717 62.9109 58.0585 55.8943 52.3851 55.8943ZM40.4794 48.0073H48.6995C48.6995 48.0073 50.6981 48.0073 50.6981 50.9515C50.6981 53.8957 49.5268 54.3147 48.1944 54.3147H40.4794V48.0073ZM48.3234 66.2204H40.4794V58.6665H48.6995C48.6995 58.6665 51.6759 58.6343 51.6759 62.5456C51.6759 65.8121 49.4946 66.1774 48.3234 66.2204Z"
                                fill="white" />
                            <path d="M75.2289 44.6548H63.5703V48.1362H75.2289V44.6548Z" fill="white" />
                            <path
                                d="M69.6415 50.1777C58.7781 50.1777 58.7888 61.0304 58.7888 61.0304C58.7888 61.0304 58.0474 71.8294 69.6415 71.8294C69.6415 71.8294 79.3122 72.3881 79.3122 64.3184H74.3372C74.3372 64.3184 74.4983 67.3593 69.8027 67.3593C69.8027 67.3593 64.8276 67.6925 64.8276 62.4488H79.4626C79.4626 62.4488 81.0637 50.1885 69.6308 50.1885L69.6415 50.1777ZM64.7847 58.6665C64.7847 58.6665 65.3864 54.3147 69.7597 54.3147C74.133 54.3147 74.0685 58.6665 74.0685 58.6665H64.7847Z"
                                fill="white" />
                            <defs>
                                <linearGradient id="paint0_linear_33_99" x1="1.10145" y1="4.6594" x2="132.761"
                                    y2="48.8175" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#262626" />
                                    <stop offset="1" stop-color="#2C2C2C" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </a>
                </div>
                <p class="muted">Stay with me</p>
                <h3 style="gap: 0;">Projects</h3>
                <router-link to="/works">
                    <div class="arrow-small">
                        <svg width="50" height="40" viewBox="0 0 50 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M30 28.75C30 23.913 26.087 20 21.25 20C26.087 20 30 16.087 30 11.25C30 16.087 33.913 20 38.75 20C33.913 20 30 23.913 30 28.75Z"
                                stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                            <path d="M23.75 20H0" stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                            <path
                                d="M12.5 25.8594C14.9392 33.3452 21.925 38.75 30.1622 38.75C40.428 38.75 48.75 30.3553 48.75 20C48.75 9.64466 40.428 1.25 30.1622 1.25C21.925 1.25 14.9392 6.65485 12.5 14.1406"
                                stroke="#444444" stroke-width="1.25" />
                        </svg>
                    </div>
                </router-link>
            </div>
            <div class="card cta-card">
                <img class="decor-icon" src="@/assets/images/second-arrow.png" alt="Decor" />
                <h2>Let’s <span><br>work</span> <span class="highlight">together.</span></h2>
                <div class="arrow-small cta-arrow">
                    <router-link to="/contact">
                        <svg width="50" height="40" viewBox="0 0 50 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M30 28.75C30 23.913 26.087 20 21.25 20C26.087 20 30 16.087 30 11.25C30 16.087 33.913 20 38.75 20C33.913 20 30 23.913 30 28.75Z"
                                stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                            <path d="M23.75 20H0" stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                            <path
                                d="M12.5 25.8594C14.9392 33.3452 21.925 38.75 30.1622 38.75C40.428 38.75 48.75 30.3553 48.75 20C48.75 9.64466 40.428 1.25 30.1622 1.25C21.925 1.25 14.9392 6.65485 12.5 14.1406"
                                stroke="#444444" stroke-width="1.25" />
                        </svg>
                    </router-link>

                </div>
            </div>
            <div class="card signature-card">
                <div class="img_center">
                    <lottie-player :src="require('@/assets/lottie/Signature.json')" class="ticker-animation"
                        background="transparent" speed="1" style="width: 100%; height: 80%;" loop autoplay>
                    </lottie-player>
                </div>
                <p class="muted">More about me</p>
                <h3>Credentials</h3>
                <div class="arrow-small">
                    <svg width="50" height="40" viewBox="0 0 50 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M30 28.75C30 23.913 26.087 20 21.25 20C26.087 20 30 16.087 30 11.25C30 16.087 33.913 20 38.75 20C33.913 20 30 23.913 30 28.75Z"
                            stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                        <path d="M23.75 20H0" stroke="#444444" stroke-width="1.25" stroke-miterlimit="10" />
                        <path
                            d="M12.5 25.8594C14.9392 33.3452 21.925 38.75 30.1622 38.75C40.428 38.75 48.75 30.3553 48.75 20C48.75 9.64466 40.428 1.25 30.1622 1.25C21.925 1.25 14.9392 6.65485 12.5 14.1406"
                            stroke="#444444" stroke-width="1.25" />
                    </svg>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'About',
    data() {
        return {
            lottieSource: require('@/assets/lottie/Proflie Pic - About US.json')
        };
    }
}
</script>

<style scoped>
.about-section {
    background: #111;
    padding: 85px 20px;
    color: #f5f3ef;
    margin-top: 40px;
}

.summary-layout {
    display: flex;
    align-items: flex-start;
    justify-content: start;
    width: 100%;
    gap: 20px;
    margin-bottom: 20px;

}

.summary-image {
    background: #1d1d1d;
    border-radius: 32px;
    border: 1px solid #2c2c2c;
}

.summary-image lottie-player {
    width: 348px;
    height: 340px;
    object-fit: cover;
    padding: 25px;
    border-radius: 12px;
}

.summary-text {
    display: flex;
    flex-direction: column;
    /* gap: 31px; */
    max-width: 100%;
}

.summary-text lottie-player {
    width: 100%;
    height: 100%;
    margin-top: 35px;
    margin-bottom: 35px;
}

.section-title {
    font-size: 76px;
    font-weight: 500;
    text-align: center;
    color: #fff;
    margin: 0;

}

.asterisk img {
    width: 45px;
    height: 45px;
    opacity: 0.3;
}

.summary-box {
    background: linear-gradient(109deg, #1d1d1d, #121212);
    border-radius: 32px;
    padding: 15px 32px;
    position: relative;
    border: 1px solid #2c2c2c;
}

.decor-icon {
    position: absolute;
    top: 0;
    left: 45px;
    width: 35px;
    opacity: 0.8;
}

.summary-box h2 {
    font-size: 42px;
    font-weight: 400;
    color: #fff;
    margin-top: 75px;
    margin-bottom: 0;
}

.summary-box p {
    font-size: 18px;
    line-height: 140%;
    color: #F5F3EF;
    font-weight: 300;
    margin-top: 5px;
}

.card-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
}

.card {
    background: linear-gradient(109deg, #1d1d1d, #121212);
    border-radius: 32px;
    padding: 24px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: 1px solid #2c2c2c;
}


.card h3 {
    font-size: 24px;
    margin: 0;
    color: #fff;
    font-weight: 400;
}

.card p {
    font-size: 18px;
    font-weight: 300;
    margin-bottom: 4px;
}

.muted {
    color: #444444;
    font-family: 'Sora', sans-serif;
}

.role {
    margin-top: 2px;
}

.logo-image {
    width: 60%;
}

.icon-card {
    justify-content: end;
}

.icon-card a>svg {
    width: 114px;
}


.cta-card {
    justify-content: end;
    text-align: start;
    position: relative;
    width: 550px;
    padding: 40px;
}

.cta-card h2 {
    font-size: 48px;
    font-weight: 500;
    color: #fff;
    margin-bottom: -15px;
}

.cta-card .highlight {
    color: #F63E02;
    font-weight: 500;
}

.signature-card img {
    width: 60%;
    margin-bottom: 10px;
    opacity: 0.7;
}

.img_center {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 15px;
}

.arrow-small {
    position: absolute;
    bottom: 25px;
    right: 35px;
    width: 40px;
}

.arrow-small img {
    width: 100%;
}

.arrow-small:hover {
    cursor: pointer;
}


.arrow-small svg:hover path {
    stroke: #ffffff;
    cursor: pointer;
}

.arrow-small svg path {
    transition: stroke 0.3s ease;
}

@media screen and (max-width: 768px) {
    .summary-layout {
        flex-direction: column;
        align-items: center;
        gap: 15px;
    }

    .summary-image {
        width: auto;
        padding: 25px 25px;
    }

    .summary-image lottie-player {
        width: 350px;
        padding: 0;
        border-radius: 16px;
    }

    .summary-text {
        width: 100%;
        padding: 0 10px;
    }

    .decor-icon {
        position: relative;
        width: 38px;
        left: 0;
        top: -24px;
    }

    .section-title {
        margin-bottom: 15px;
        font-size: 32px;
        text-align: center;
        line-height: 1.2;
    }

    .asterisk {
        display: inline-block;
    }

    .asterisk img {
        width: 30px;
        height: 30px;
    }

    .summary-box {
        padding: 24px;
        text-align: center;
        width: 100%;
        box-sizing: border-box;
    }

    .summary-box h2 {
        font-size: 48px;
        font-weight: 500;
        margin-top: 0px;
    }

    .summary-box p {
        font-size: 18px;
        font-weight: 300;
        line-height: 140%;
        margin: 12px 4px;
        margin-top: 24px;
    }

    .card-grid {
        grid-template-columns: 1fr;
        gap: 24px;
        margin-top: 24px;
    }

    .card {
        width: 100%;
        box-sizing: border-box;
    }

    .cta-card {
        width: 100%;
        text-align: left;
        padding: 24px;
        padding-right: 0;
    }

    .cta-arrow {
        display: none;
    }

    .cta-card h2 {
        font-size: 40px;
        line-height: 1.3;
        margin-top: 0;
        margin-bottom: 0;
    }

    .cta-card img {
        width: 37px;
        height: 86px;
        left: 8px;
        top: -24px;
    }

    .icon-card img {
        width: 100px;
    }

    .signature-card img,
    .logo-image {
        width: 70%;
    }

    .signature-card p {
        margin-bottom: 0;
    }

    .img_center {
        margin: 20px auto;
    }

    .arrow-small img {
        width: 40px;
        bottom: 12px;
        right: 12px;
    }

    .summary-text lottie-player {
        width: 100%;
        height: 100%;
        margin-top: 9px;
        margin-bottom: 24px;
    }
}
</style>